var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('icon-title');
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from './icon';
export var IconTitleSizes = {
  "veryLarge": 48,
  "large": 32,
  "medium": 24,
  "small": 18,
  "tiny": 18
};
export var IconTitleFontSizes = {
  "veryLarge": 36,
  "large": 28,
  "medium": 18,
  "small": 15,
  "tiny": 13
};
export var IconTitleTopPadding = {
  "veryLarge": 3,
  "large": 1,
  "medium": 2,
  "small": 1,
  "tiny": 2
};
export var IconTitleDefaultProps = {
  size: 'large'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-weight: 400;\n    display: flex;\n    line-height: 1.1em;\n    margin: 0;\n    align-items: flex-start;\n    ", "\n  "], ["\n    font-weight: 400;\n    display: flex;\n    line-height: 1.1em;\n    margin: 0;\n    align-items: flex-start;\n    ", "\n  "])), function (_a) {
    var size = _a.size;
    return size !== 'inherit' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-size: ", "px;\n    "], ["\n      font-size: ", "px;\n    "])), IconTitleFontSizes[size]);
  }),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\n  "], ["\n\n  "]))),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex-shrink: 0;\n    margin-right: ", ";\n    ", "\n  "], ["\n    flex-shrink: 0;\n    margin-right: ", ";\n    ", "\n  "])), theme.UNIT(2), function (_a) {
    var iconSize = _a.iconSize;
    return iconSize !== 'inherit' && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n    "])), IconTitleSizes[iconSize], IconTitleSizes[iconSize]);
  }),
  tablet: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-top: 0px;\n    ", "\n  "], ["\n    margin-top: 0px;\n    ", "\n  "])), function (_a) {
    var iconSize = _a.iconSize;
    return iconSize !== 'inherit' && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n    "])), IconTitleSizes[iconSize], IconTitleSizes[iconSize]);
  }),
  desktop: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    margin-top: 0px;\n    ", "\n  "], ["\n    margin-top: 0px;\n    ", "\n  "])), function (_a) {
    var iconSize = _a.iconSize;
    return iconSize !== 'inherit' && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n    "])), IconTitleSizes[iconSize], IconTitleSizes[iconSize]);
  })
});
var NameStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    margin-top: 2px;\n    text-overflow: ellipsis;\n    ", "\n  "], ["\n    margin-top: 2px;\n    text-overflow: ellipsis;\n    ", "\n  "])), function (_a) {
    var iconSize = _a.iconSize;
    return iconSize !== 'inherit' && css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      padding-top: ", "px;\n    "], ["\n      padding-top: ", "px;\n    "])), IconTitleTopPadding[iconSize]);
  }),
  tablet: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    margin-top: 0;\n  "], ["\n    margin-top: 0;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.h1(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: styled(Icon)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Name: styled.span.attrs(cls.attr('name'))(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), NameStyles)
};
export var IconTitle = function IconTitle(props) {
  var children = props.children,
      className = props.className,
      size = props.size;
  var Icon = props.icon;
  return React.createElement(My.Container, {
    size: size,
    className: cls.name(className)
  }, Icon && React.createElement(My.Icon, {
    iconSize: size
  }, React.createElement(Icon, null)), React.createElement(My.Name, {
    iconSize: size
  }, children));
};
IconTitle.defaultProps = IconTitleDefaultProps;
IconTitle.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;